import { c as _c } from "react/compiler-runtime";
import { FocusEventHandler, useCallback, useState } from 'react';
export function useIsFocused(options) {
  const $ = _c(8);
  const {
    onBlur,
    onFocus
  } = options;
  const [isFocused, setIsFocused] = useState(false);
  let t0;
  if ($[0] !== onFocus) {
    t0 = event => {
      onFocus?.(event);
      setIsFocused(true);
    };
    $[0] = onFocus;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleFocus = t0;
  let t1;
  if ($[2] !== onBlur) {
    t1 = event_0 => {
      onBlur?.(event_0);
      setIsFocused(false);
    };
    $[2] = onBlur;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleBlur = t1;
  let t2;
  if ($[4] !== handleBlur || $[5] !== handleFocus || $[6] !== isFocused) {
    t2 = {
      isFocused,
      handleFocus,
      handleBlur
    };
    $[4] = handleBlur;
    $[5] = handleFocus;
    $[6] = isFocused;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export type UseIsFocusedOptions<TFocusTarget> = {
  /**
   * event handler to call on focus
   */
  onFocus?: FocusEventHandler<TFocusTarget>;

  /**
   * event handler to call on blur
   */
  onBlur?: FocusEventHandler<TFocusTarget>;
};